import React from 'react';
import ErrorLogTester from '../components/ErrorLogTester';
import { appLogger } from '../utils/errorLogger';

const ErrorTestPage: React.FC = () => {
  // Log page view for testing
  React.useEffect(() => {
    appLogger.info('Error Test Page viewed', {
      source: 'error-test-page',
      path: window.location.pathname
    });
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Error Logging Test Page</h1>
      
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Frontend Error Testing</h2>
        <p className="mb-4">
          Use the buttons below to test different types of error logging in the frontend.
          All errors should be captured and sent to the CRM.
        </p>
        <ErrorLogTester />
      </div>
      
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Backend Error Testing</h2>
        <p className="mb-4">
          Use these links to test different types of error logging in the backend.
          All errors should be captured and sent to the CRM.
        </p>
        <div className="space-y-2">
          <div>
            <a 
              href="/api/test/log-error" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Test Manual Server Error Log
            </a>
            <p className="text-sm text-gray-600">Tests direct error logging through the serverLogger utility</p>
          </div>
          
          <div>
            <a 
              href="/api/test/trigger-error" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Test Server Error Handler
            </a>
            <p className="text-sm text-gray-600">Tests error handler middleware by triggering a server error</p>
          </div>
          
          <div>
            <a 
              href="/api/test/db-error" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Test Database Error
            </a>
            <p className="text-sm text-gray-600">Tests database error handling and categorization</p>
          </div>
          
          <div>
            <a 
              href="/api/test/auth-error" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Test Authentication Error
            </a>
            <p className="text-sm text-gray-600">Tests authentication error handling and categorization</p>
          </div>
        </div>
      </div>
      
      <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
        <h3 className="font-medium text-yellow-800 mb-2">Verification Instructions</h3>
        <p className="text-yellow-700">
          After triggering errors using the buttons and links above, check your CRM system at{' '}
          <a 
            href="https://crm.maine-stream.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline"
          >
            https://crm.maine-stream.com
          </a>{' '}
          to verify that the errors are being properly logged.
        </p>
      </div>
    </div>
  );
};

export default ErrorTestPage;
